import React, { ReactNode } from "react";
import IconWarning from "./icons/IconWarning";

export default function Disclaimer({ children }: { children: ReactNode }) {
  if (!children) {
    return null;
  }
  return (
    <div className="flex items-center border-l-8 rounded-lg border-[#E2B93B] bg-gray-100">
      <div className="p-8">
        <IconWarning />
      </div>
      <div className="py-8 pr-8 italic font-light font-md">{children}</div>
    </div>
  );
}
